import 'babel-polyfill';
import 'classlist-polyfill';
import elementDatasetPolyfill from 'element-dataset';

import $ from 'jquery';
import moment from 'moment';
import 'select2/dist/js/i18n/ru';
import {constants} from './common';

elementDatasetPolyfill();

class AccessibilityController {

    constructor(toggleID, containerID, imagesToggleID) {
        this.toggle_ = document.getElementById(toggleID);
        this.container = document.getElementById(containerID);
        this.activated = false;
        this.imagesToggle = document.getElementById(imagesToggleID);
        this.themeHolder = document.getElementById("theme-holder");
        this.fontSize = "font-size-standard";
        this.intervalSize = "interval-standard";
    }

    init() {
        if(constants.lite_map)
            return;

        this.toggle_.addEventListener("click", event => {
            event.preventDefault();
            if (this.activated) {
                this.container.style.display = "none";
                this.activated = false;
            } else {
                this.container.style.display = "block";
                this.activated = true;
            }
        });

        this.imagesToggle.addEventListener("change", () => {
            this.toggleImages();
            this.send();
        });

        let sizeButtons = document.getElementById("size-btns").children;
        for (let i = 0; i < sizeButtons.length; i++) {
            let btn = sizeButtons[i];
            btn.addEventListener("click", event => {
                event.preventDefault();
                let sizes = ['standard', 'largest', 'enlarged'];
                let size = `font-size-${btn.dataset.size}`;
                let bodyClasses = document.body.classList;
                if (!bodyClasses.contains(size)) {
                    for (let s of sizes) {
                        document.body.classList.remove(`font-size-${s}`);
                    }

                    document.body.classList.add(size);
                    this.fontSize = size;
                    this.send();
                }
            })
        }

        let intervalButtons = document.getElementById("interval-btns").children;

        for (let i = 0; i < intervalButtons.length; i++) {
            let btn = intervalButtons[i];
            btn.addEventListener("click", event => {
                event.preventDefault();
                let intervals = ['standard', 'largest', 'enlarged'];
                let interval = `interval-${btn.dataset.interval}`;
                let bodyClasses = document.body.classList;
                if (!bodyClasses.contains(interval)) {
                    for (let i of intervals) {
                        document.body.classList.remove(`interval-${i}`);
                    }

                    document.body.classList.add(interval);
                    this.intervalSize = interval;
                    this.send();
                }
            })
        }

        let colorSchemes = document.getElementsByClassName("color-scheme-btn");

        for (let i = 0; i < colorSchemes.length; i++) {
            let colorScheme = colorSchemes[i];
            let style = colorScheme.getAttribute('data-style');
            if (style !== null) {
                colorScheme.addEventListener("click", event => {
                    event.preventDefault();
                    this.themeHolder.href = style;
                    this.send();
                })
            }
        }

        this.toggleImages();
    }

    toggleImages() {
        let body = document.body;
        if (this.imagesToggle.checked) {
            body.classList.add("accessibility-img-off");
        } else {
            body.classList.remove("accessibility-img-off");
        }
    }

    send() {
        $.ajax({
            url: '/user/accessibility/',
            type: 'POST',
            data: JSON.stringify({
                images: this.imagesToggle.checked,
                theme: this.themeHolder.href,
                fontSize: this.fontSize,
                intervalSize: this.intervalSize
            }),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        })
    }
}

class Application {

    constructor() {
        this.accessibilityController = new AccessibilityController("accessibility-toggle", "accessibility-container", "accessibility-toggle-image");
    }

    init() {
        $.ajaxSetup({
            beforeSend: function (xhr, settings) {
                if (!csrfSafeMethod(settings.type) && sameOrigin(settings.url)) {
                    xhr.setRequestHeader("X-CSRFToken", document.getElementsByName("csrfmiddlewaretoken")[0].value);
                }
            }
        });

        this.accessibilityController.init();
    }
}

function csrfSafeMethod(method) {
    return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
}

function sameOrigin(url) {
    let host = document.location.host; // host + port
    let protocol = document.location.protocol;
    let sr_origin = '//' + host;
    let origin = protocol + sr_origin;
    return (url === origin || url.slice(0, origin.length + 1) === origin + '/') ||
        (url === sr_origin || url.slice(0, sr_origin.length + 1) === sr_origin + '/') || !(/^(\/\/|http:|https:).*/.test(url));
}

let application = new Application();
application.init();

/* OLD BROWSERS */
let $buoop = {vs: {i: 10, f: 25, o: 12.9, s: 7}, c: 2};
function $buo_f() {
    let e = document.createElement("script");
    let paths = document.location.pathname.split('/');
    e.src = "//browser-update.org/update.min.js";
    if(paths.indexOf('karta') === -1)
        document.body.appendChild(e);
}

try {
    document.addEventListener("DOMContentLoaded", $buo_f, false)
} catch (e) {
    window.attachEvent("onload", $buo_f)
}

if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement, fromIndex) {

        let k;

        // 1. Let O be the result of calling ToObject passing
        //    the this value as the argument.
        if (this === null) {
            throw new TypeError('"this" is null or not defined');
        }

        let O = Object(this);

        // 2. Let lenValue be the result of calling the Get
        //    internal method of O with the argument "length".
        // 3. Let len be ToUint32(lenValue).
        let len = O.length >>> 0;

        // 4. If len is 0, return -1.
        if (len === 0) {
            return -1;
        }

        // 5. If argument fromIndex was passed let n be
        //    ToInteger(fromIndex); else let n be 0.
        let n = +fromIndex || 0;

        if (Math.abs(n) === Infinity) {
            n = 0;
        }

        // 6. If n >= len, return -1.
        if (n >= len) {
            return -1;
        }

        // 7. If n >= 0, then Let k be n.
        // 8. Else, n<0, Let k be len - abs(n).
        //    If k is less than 0, then let k be 0.
        k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

        // 9. Repeat, while k < len
        while (k < len) {
            // a. Let Pk be ToString(k).
            //   This is implicit for LHS operands of the in operator
            // b. Let kPresent be the result of calling the
            //    HasProperty internal method of O with argument Pk.
            //   This step can be combined with c
            // c. If kPresent is true, then
            //    i.  Let elementK be the result of calling the Get
            //        internal method of O with the argument ToString(k).
            //   ii.  Let same be the result of applying the
            //        Strict Equality Comparison Algorithm to
            //        searchElement and elementK.
            //  iii.  If same is true, return k.
            if (k in O && O[k] === searchElement) {
                return k;
            }
            k++;
        }
        return -1;
    };
}

if (window.navigator.userAgent.match(/Chrome\/\w+\.\w+/i)) {
    $("head").append("<style>.banner:after{box-shadow: none !important}</style>");
}


function setLoadingPlaceholder(elements) {
    return elements.each(function (idx, elem) {
        let el = $(elem);
        el.attr('orig_placeholder', el.attr('placeholder'));
    })
        .attr('placeholder', 'Загрузка данных...')
        .attr('disabled', true);
}


$(document).ready(function () {
    $(".carousel").each(function (ind, slider) {
        if ($(slider).find(".item").length <= 1) {
            $(slider).find(".carousel-control").hide()
        }
    });

    $('.banner#slider').on('slide.bs.carousel', function (e) {
        let next = $(e.relatedTarget).data('name');
        $(this).attr("data-bg", next);
    });

    let cpsSearch = $('.checkpoints-search').on('select2-open', function () {
        $(this).select2('dropdown').addClass('checkpoints-height-fix');
    });


    setLoadingPlaceholder(cpsSearch);
    setLoadingPlaceholder($('.routes-search'));

    $('.filer_image').filter(function () {
        return $(this).closest('.poll-form, .poll').length === 0
    }).wrap('<a class="fancybox" rel="gallery"></a>').each(function (idx, el) {
        $(el.parentElement).attr('href', $(el).attr('src'));
    });


    /* Воркэраунд случайного дублирования отправки формы */
    $(document).on('submit', '.bulletproof-form', function () {
        let button = $(this).find('.form-submit');
        $(button).attr('disabled', 'disabled');
        $(button).text('Отправка...');
        return true;
    });

    // image menu animation
    let count_menu_items = $('.image_menu-item').length,
        timer;
    $('.image_menu-item').css('width', 100/count_menu_items+'%');
    $('.image_menu-item').hover(
        function (){
            let me = this;
            if(timer) {
                clearTimeout(timer);
                timer = null
            }
            timer = setTimeout(function(){
                $('.image_menu-item').css('width', 50/(count_menu_items-1)+'%');
                $(me).css('width', '50%');
            }, 300);
        },
        function(){
            clearTimeout(timer);
            $('.image_menu-item').css('width', 100/count_menu_items+'%');
        }
    );
});

export function formatRouteArray(route) {
    return route.text;
}

export function formatRouteArraySelection(route) {
    return route.text;
}



$(".select-checkpoints").select2({
    language: "ru",
    theme: "bootstrap",
    allowClear: true,
    ajax: {
        url: `${constants.host}/api/v5/checkpointsforsearch/`,
        dataType: 'json',
        delay: 250,
        data: function (params) {
            let date = $('#date').val();
            let route = [];

            if($(".schedule-form-select-routes").data('select2'))
                route = $(".schedule-form-select-routes").select2('data');

            if (route !== undefined && route.length !== 0)
                route = route[0].id;

            let data = {};

            if (params.term !== undefined && params.term !== "") {
                data.query_text = params.term
            }

            if (route !== "") {
                data.route_id = route;
            }

            if (date !== undefined) {
                data.date = moment(date, "DD.MM.YYYY").format("YYYY-MM-DD")
            }

            return data;
        },
        processResults: function (data) {
            return {
                results: data.objects
            };
        }
    },
    escapeMarkup: function (markup) {
        return markup;
    },

    minimumInputLength: 3,
    templateResult: formatCheckpoint,
    templateSelection: formatCheckpointSelection
});


function formatCheckpoint(checkpoint) {
    if (checkpoint.loading) return checkpoint.text;

    return "<div class='select2-result-checkpoints clearfix'>" +
        "<div class='select2-result-checkpoints__name'>" + checkpoint.name + " - " + checkpoint.code_number + "</div>" +
        "<div class='select2-result-checkpoints__description'>" + checkpoint.description + "</div>" +
        "</div>";
}

function formatCheckpointSelection(checkpoint) {
    return checkpoint.name;
}

if(constants.production) {
    (function (d, w, c) {
        (w[c] = w[c] || []).push(function () {
            try {
                w.yaCounter13837582 = new Ya.Metrika({
                    id: 13837582,
                    clickmap: true,
                    trackLinks: true,
                    accurateTrackBounce: true,
                    webvisor: true
                });
            } catch (e) {

            }
        });

        let n = d.getElementsByTagName("script")[0],
            s = d.createElement("script"),
            f = function () {
                n.parentNode.insertBefore(s, n);
            };
        s.type = "text/javascript";
        s.async = true;
        s.src = (d.location.protocol === "https:" ? "https:" : "http:") + "//mc.yandex.ru/metrika/watch.js";

        if (w.opera === "[object Opera]") {
            d.addEventListener("DOMContentLoaded", f, false);
        } else {
            f();
        }
    })(document, window, "yandex_metrika_callbacks");
}


let owl = $("#index-evacuation");

owl.owlCarousel({
    loop: true,
    margin: 10,
    responsiveClass: true,
    autoplay: true,
    autoplayHoverPause: true,
    responsive: {
        0: {
            items: 2
        },
        400: {
            items: 3
        },
        500: {
            items: 3
        },
        600: {
            items: 4
        },
        1000: {
            items: 3
        }
    }
});

$(".previous").click(function () {
    owl.owlCarousel().trigger('prev.owl.carousel');
});

$(".next").click(function () {
    owl.owlCarousel().trigger('next.owl.carousel');
});


// Карусель новостей на главной
let newsCarousel = $("#news-carousel");
newsCarousel.owlCarousel({
    items: 4,
    margin: 20,
    nav: false,
    dots: false,
    mouseDrag: false,
    onChanged: newsCarouselChanged,
    responsive: {
        0: {
            items: 1
        },
        400: {
            items: 1
        },
        500: {
            items: 2
        },
        600: {
            items: 3
        },
        1000: {
            items: 4
        }
    }
});
$("#news-carousel-left").click(function () {
    newsCarousel.owlCarousel().trigger('prev.owl.carousel');
});
$("#news-carousel-right").click(function () {
    newsCarousel.owlCarousel().trigger('next.owl.carousel');
});
function newsCarouselChanged(event){
    let items = event.item.count,
        item = event.item.index;
    $("#news-carousel-left, #news-carousel-right").addClass('active');
    if(item === 0)
        $("#news-carousel-left").removeClass('active');
    if(item === items - 4)
        $("#news-carousel-right").removeClass('active');
}

$.get('/map/is_local', function (data) {
    if (typeof data === 'object') {
        if (data.is_local) {
            $('.top_menu:first .navbar-main ul.dropdown-menu:last').append('<li><a href="/o-nas/spravochnik/">Телефонный справочник</a></li>');
            $('.top_menu:last .navbar-main ul.dropdown-menu:last').append('<li><a href="/o-nas/spravochnik/">Телефонный справочник</a></li>');
        }
    }
});

$(".svetofory_query").on('click', function () {
    let ansver_id = $(this).attr('href');
    if(ansver_id.length)
        ansver_id = ansver_id.replace('#', '');
    $('#svetofory_ansver_'+ansver_id).toggle();
    return false;
});


// WEBPACK FOOTER //
// ./src/js/site.js